import { i18nTranslationHelper } from '@/i18n'

export namespace Shift {
  const t = i18nTranslationHelper.getTEnums
  export class Enum {
    static readonly MORNING = new Enum('MORNING', t('shift.MORNING.name'))

    static readonly AFTERNOON = new Enum('AFTERNOON', t('shift.AFTERNOON.name'))

    static readonly EVENING = new Enum('EVENING', t('shift.EVENING.name'))

    public constructor(
      public readonly name: string,
      public readonly title: string
    ) {}
  }

  export const getByName = (name: string): Enum => {
    return Object.values(Shift.Enum).find(shift => shift.name === name)
  }
}
